import { Content as AntContent } from 'antd/es/layout/layout';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import '~/shared/components/content/content.scss';

type ContentPropsType = {
  isSmall?: boolean;
  isFullWidth?: boolean;
  isGreyBackground?: boolean;
  isPageContent?: boolean;
  children: ReactNode;
  className?: string;
};

const Content = ({
  isFullWidth = false,
  isPageContent = false,
  isGreyBackground = false,
  isContainer = false,
  children,
  isSmall,
  className,
}: ContentPropsType) => (
  <AntContent
    className={classNames(
      {
        container: !isFullWidth,
        content: !isFullWidth,
        'content--page': isPageContent,
        'content--small': isSmall,
        'content--full-width': isFullWidth,
        'content--container': isContainer,
        'content--grey-bg': isGreyBackground,
      },
      className,
    )}
  >
    {children}
  </AntContent>
);

export default Content;
